import React, {useEffect} from 'react';
import styles from "./registration.module.scss";
import {Button, Form, Input, message as messageAnt} from 'antd';
import {useHttp} from "../../hooks/http.hook";
import {AppRoutes, routeConfig, RoutePath} from "../../app/routeConfig";
import {LinkProps, NavLink} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import {Languages} from "../../shared/types";
import {useNavigate} from 'react-router-dom'

const Registration = () => {

  const navigate = useNavigate();
  const {loading, request, error, clearError} = useHttp()

  const {t, i18n} = useTranslation();
  const lang = i18n.language as Languages

  const messageAboutNeedToLogin = () => {
    let message = ''
    if (lang === 'ru') {
      message = 'Пожалуйста введите логин и пароль повторно'
    } else {
      message = 'Please enter your username and password again'
    }
    setTimeout(() => {
      messageAnt.info(message)
    }, 4000)
  }

  //Регистрация пользователя на сервере
  const onFinish = async (values: any) => {
    // try {
    //   const data = await request('/api/auth/register', 'POST', {...values})
    //   // messageAnt.info(data.message)
    //   let message = ''
    //   if (lang === 'ru') {
    //     message = 'Успешная регистрация'
    //   } else {
    //     message = 'Successful registration'
    //   }
    //   messageAnt.info(message)
    //   navigate(RoutePath[AppRoutes.LOGIN])
    //   messageAboutNeedToLogin()
    // } catch (e) {
    //   // let message = e instanceof Error ? e.message : 'Что-то пошло не так'
    //   let message = ''
    //   if (lang === 'ru') {
    //     message = 'Что-то пошло не так'
    //   } else {
    //     message = 'Something went wrong.'
    //   }
    //   messageAnt.info(message)
    //   clearError()
    // }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.titleWrap}>
          {/*//@ts-ignore*/}
          <p className={styles.title}>{t('RegistrationTitle')}</p>
        </div>
        <div className={styles.form}>
          <Form name="registration" labelCol={{span: 8,}} initialValues={{remember: true,}}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off">
            <Form.Item
              /*//@ts-ignore*/
              label={t('RegistrationEmail')}
              name="email"
              rules={[{
                required: true,
                /*//@ts-ignore*/
                message: t('RegistrationEmailTip'),
              },]}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              /*//@ts-ignore*/
              label={t('RegistrationPassword')}
              name="password"
              rules={[{
                required: true,
                /*//@ts-ignore*/
                message: t('RegistrationPasswordTip'),
              },]}
            >
              <Input.Password/>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" style={{marginTop: 15}} disabled={loading}>
                {/*//@ts-ignore*/}
                {t('RegistrationButton')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Registration;